import axios from 'axios';

export { editCustomerRelationship, getRelationship }

async function editCustomerRelationship(payload){
  /**
   * Payload requires: relationshipId, buyerAccountId
   * Optional:
   *      creditLimit, creditDays, premium, spotEnabled, bunkeringEnabled, dinEnabled, restrictions
   */
    const response = await axios.put('/api/editBuyerRelationship', payload);
    return response.data.Success;
}

async function getRelationship(relationshipId){
  const relationship = (await axios.get(`/api/relationship?relationshipId=${relationshipId}`)).data.relationship;
  const relationshipObject = {
    name: relationship.buyer.name,
    id: relationship.buyer.account_id,
    credit: relationship.credit,
    premium: relationship.other.premium,
    enabled_spot: relationship.other.enabled_spot,
    enabled_bunkering: relationship.other.enabled_bunkering,
    enabled_deliveredin: relationship.other.enabled_deliveredin,
    restrictions: relationship.restrictions,
    relationshipId: relationship._id
}
  return relationshipObject;
}